import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";


import { servicesData } from "../data/servicesData";
import partnersData from "../data/partnersData";
import projectsData from "../data/projectsData";
import standardsData from "../data/standardsData";

import "./HomeStyle.css";

import banner1 from "../assets/banner/hero1.jpeg";
import banner2 from "../assets/banner/hero2.jpeg";
import banner3 from "../assets/banner/hero3.jpeg";


import ad0 from "../assets/banner/ad0.png";

import ad1 from "../assets/banner/ad1.jpeg";
import ad2 from "../assets/banner/ad2.jpeg";
import ad3 from "../assets/banner/ad3.jpeg";
import ad4 from "../assets/banner/ad4.jpeg";
import ad5 from "../assets/banner/ad5.jpeg";
import ad6 from "../assets/banner/ad6.jpeg";
import ad7 from "../assets/banner/ad7.jpeg";
import ad8 from "../assets/banner/ad8.jpeg";
import ad9 from "../assets/banner/ad9.jpeg";
import ad91 from "../assets/banner/ad91.jpeg";
import ad92 from "../assets/banner/ad92.jpeg";



// Import slick styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// ✅ At the top of the file
import {
  FaCloud,
  FaRobot,
  FaChartLine,
  FaIndustry,
  FaCogs,
  FaLightbulb,
} from "react-icons/fa";
import { AiOutlineLineChart } from "react-icons/ai";
import { GiArtificialIntelligence } from "react-icons/gi";

function Home() {

const navigate = useNavigate();

  const truncateText = (t, limit = 200) =>
    t && t.length > limit ? t.substring(0, limit) + "..." : t;

  // ✅ Hero slide content
  const heroSlides = [
    {
      image: banner1,
      title: "smarter, cleaner, and  efficient solutions ",
      description:"",
      buttonText: "",
      buttonLink: "/services",
    },
    {
      image: banner2,
      title: "  relentless research and innovation",
      description:"",
      buttonText: "",
      buttonLink: "/projects",
    },
    {
      image: banner3,
      title: " execution  with experience  and reliabity",
      description:"",
      buttonText: "",
      buttonLink: "/team",
    },
  ];

  // ✅ Slider settings
  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: true,
  };


  const [projects, setProjects] = useState([]);
  const [pageInfo, setPageInfo] = useState({ title: "", description: "", footnote: "" });

const fetchData = async () => {
  try {
    const response = await fetch('https://goke.in/api/projects');
    const data = await response.json();

        setPageInfo(data.page || {});
        const projects = data.lists || [];
        setProjects(projects);
    console.log(data);
    // Do something with the data
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

  useEffect(() => {
    fetchData();
  }, []);

  const getProjectImage = (proj) => {
    if (proj.images && typeof proj.images === "object") {
      if (proj.primary_image && proj.images[proj.primary_image]) {
        return proj.images[proj.primary_image];
      }
      const firstImage = Object.values(proj.images).find((url) => !!url);
      if (firstImage) return firstImage;
    }
    return proj.image || null;
  };

  return (

    <div className="home-container">
      {/* ✅ Hero Section (Dynamic Carousel) */}
      <section className="hero-slider">
        <Slider {...sliderSettings}>
          {heroSlides.map((slide, index) => (
            <div key={index} className="hero-slide">
              <img src={slide.image} alt={`Slide ${index + 1}`} className="hero-image" />
              <div className="hero-overlay">
                <h1 className=" w3-lineheight-90 w3-uppercase">{slide.title}</h1>
                <p>{slide.description}</p>
                <Link to={slide.buttonLink} className="w3-hide hero-btn">
                  {slide.buttonText}
                </Link>
              </div>
            </div>
          ))}
        </Slider>
      </section>

         {/* ✅ Highlighta */}
      <section className="snapshot-section">
        <header className="work-header w3-center">
     
<div className="w3-content">
       <img 
  src={ad0} 
  alt="" 
  className="img-responsive" 
  style={{ width: '100%', height: 'auto' }} 
/>
</div>

      </header>
      </section>




      {/* ✅ Highlighta */}
         <section className="cta-section">
        <h1  className="w3-700 w3-uppercase w3-line-height-90 w3-hide-small">Bessco powering a energy  that’s clean, strong, and ethically driven
        </h1>

        <h4  className="w3-700 w3-uppercase w3-line-height-90 w3-hide-large "> Bessco powering a energy  that’s clean, strong, and ethically driven
        </h4>
      </section>


   

      {/* ✅ Services Snapshot */}
      <section id="services" className="snapshot-section">       
        <div className="snapshot-grid"> 
            <div  className="snapshot-card">
              <img src={ad1} alt="" className=" "/>
            </div> 
              <div  className="snapshot-card">
              <img src={ad2} alt="" className=" "/>
            </div> 

              <div  className="snapshot-card">
                  <img src={ad3} alt="" className=" "/>
            </div> 
              <div  className="snapshot-card">
              <img src={ad4} alt="" className=" "/>
            </div> 
        </div>

      </section>


      {/* ✅ Highlighta */}
         <section className="cta-section">
        <h1  className="w3-700 w3-uppercase w3-line-height-95 w3-hide-small ">
        To be a global leader in renewable energy, driving innovation in solar, wind, and energy storage, while making clean power accessible to every household and enterprise
        </h1>

           <h4  className="w3-700 w3-uppercase w3-line-height-100 w3-hide-large ">
        To be a global leader in renewable energy, driving innovation in solar, wind, and energy storage, while making clean power accessible to every household and enterprise
        </h4>

      </section>



  {/* ✅ Services Snapshot */}
      <section id="services" className="snapshot-section">       
        <div className="snapshot-grid"> 
            <div  className="snapshot-card">
              <img src={ad5} alt="" className=" "/>
            </div> 
              <div  className="snapshot-card">
              <img src={ad6} alt="" className=" "/>
            </div> 
 
              <div  className="snapshot-card">
              <img src={ad7} alt="" className=" "/>
            </div> 
        </div>

      </section>



         {/* ✅ CTA */}
          <section className="cta-section">
        <h1  className="w3-700 w3-uppercase w3-line-height-95 w3-hide-small">
    To empower communities and businesses with sustainable, affordable, and innovative green energy solutions that reduce carbon footprints and accelerate the transition to a cleaner future.
        </h1>

            <h4 className="w3-700 w3-uppercase w3-line-height-100 w3-hide-large ">
    To empower communities and businesses with sustainable, affordable, and innovative green energy solutions that reduce carbon footprints and accelerate the transition to a cleaner future.
        </h4>
      </section>


  {/* ✅ Services Snapshot */}
      <section id="services" className="snapshot-section">       
        <div className="snapshot-grid"> 
              <div  className="snapshot-card">
              <img src={ad8} alt="" className=" "/>
            </div> 

            <div  className="snapshot-card">
              <img src={ad91} alt="" className=" "/>
            </div> 

            

            <div  className="snapshot-card">
              <img src={ad92} alt="" className=" "/>
            </div> 

              <div  className="snapshot-card">
                  <img src={ad9} alt="" className=" "/>
            </div> 

        </div>

      </section>

      {/* ✅ Highlighta */}
      <section className="snapshot-section alt-bg">
       <header className="work-header w3-center">
     
<div className="w3-content">
       <img 
  src={ad0} 
  alt="" 
  className="img-responsive" 
  style={{ width: '100%', height: 'auto' }} 
/>
</div>

      </header>
      </section>




    </div>
  );
}

export default Home;
